import { useRef, useState, useEffect } from "react";

export default function ClickToPlayVideo({ src, poster, targetImgRef }) {
  const videoRef = useRef(null);
  const containerRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [hover, setHover] = useState(false);
  const [width, setWidth] = useState("auto");

  // Match the width of the target image at runtime
  useEffect(() => {
    const updateWidth = () => {
      if (targetImgRef?.current) {
        setWidth(targetImgRef.current.offsetWidth);
      }
    };

    updateWidth();
    window.addEventListener("resize", updateWidth);

    return () => window.removeEventListener("resize", updateWidth);
  }, [targetImgRef]);

  const handleClick = () => {
    const video = videoRef.current;
    if (!video) return;

    if (isPlaying) {
      video.pause();
      setIsPlaying(false);
    } else {
      video.muted = false;
      video.play()
        .then(() => setIsPlaying(true))
        .catch(err => console.error("Play failed:", err));
    }
  };

  const handleEnded = () => {
    setTimeout(() => {
      const video = videoRef.current;
      if (video) video.currentTime = 0;
      setIsPlaying(false);
    }, 2000);
  };

  return (
    <div
      ref={containerRef}
      className="single portrait fs-height-video"
      style={{ position: "relative", display: "inline-block", width }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <video
        ref={videoRef}
        className="vid"
        src={src}
        poster={poster}
        playsInline
        controls={false}
        onClick={handleClick}
        onEnded={handleEnded}
        style={{ width: "100%", height: "auto", cursor: "pointer", display: "block" }}
      />

      {/* Overlay Icon */}
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          pointerEvents: "none",
          userSelect: "none",
        }}
      >
        {!isPlaying ? (
          // Play Icon
          <div
            style={{
              width: 0,
              height: 0,
              borderTop: "15px solid transparent",
              borderBottom: "15px solid transparent",
              borderLeft: "25px solid white",
            }}
          />
        ) : hover ? (
          // Pause Icon
          <div style={{ display: "flex", gap: "6px" }}>
            <div style={{ width: "8px", height: "30px", background: "white" }} />
            <div style={{ width: "8px", height: "30px", background: "white" }} />
          </div>
        ) : null}
      </div>
    </div>
  );
}
